import { useJoinLivekitMutation } from "@/graphql/generated";
import { useCallback, useEffect, useMemo, useState } from "react";

export function useLivekitToken(bioArcRoomId?: string) {
  const [joinLivekit, { data, loading, error }] = useJoinLivekitMutation();
  useEffect(() => {
    if (error) {
      console.error("JoinLivekit error:", error);
    }
  }, [error]);

  const [token, setToken] = useState<string>();

  const prepare = useCallback(async () => {
    if (!bioArcRoomId) return;
    if (token) return;
    if (loading) return;
    try {
      const result = await joinLivekit({ variables: { bioArcRoomId } });
      const data = result.data;
      const res = data?.room?.join;
      if (res?.success && res.livekitToken) setToken(res.livekitToken);
    } catch (e) {
      console.error("JoinLivekit error:", e);
    }
  }, [bioArcRoomId, joinLivekit, token, loading]);

  return useMemo(
    () =>
      ({
        joinLivekitError: error?.message || "",
        token,
        prepare,
        isPreparing: loading,
        roomData: data?.room.join.roomData,
      }) as const,
    [data?.room.join.roomData, loading, prepare, error, token]
  );
}
